import { useState, useEffect } from "react";
import styled, { keyframes } from "styled-components";
import { Box, Text } from "@vinomofo/components";
import { ReturnsIcon, TagIcon, TruckIcon } from "@vinomofo/icons";

const marketPromises = {
  AU: [
    { Icon: TagIcon, label: "Epic deals" },
    { Icon: TruckIcon, label: "Free shipping on 3+ cases" },
    { Icon: ReturnsIcon, label: "Free returns" },
  ],
  SG: [
    { Icon: TagIcon, label: "Epic wine deals" },
    { Icon: TruckIcon, label: "Free shipping on orders over $200" },
    { Icon: ReturnsIcon, label: "Free returns" },
  ],
};

const fadeInOut = keyframes`
  0% { opacity: 0; }
  20% { opacity: 1; }
  80% { opacity: 1; }
  100% { opacity: 0; }
`;

const PromiseBox = styled(Box)`
  display: flex;
  align-items: center;
  display: ${({ show }) => (show ? "flex" : "none")};
  animation: ${({ fade }) => (fade ? fadeInOut : "")} 5s linear infinite;
  white-space: nowrap;
  * + * {
    margin-left: 10px;
  }
  @media ${({ theme }) => theme.mq.min.tablet} {
    display: flex;
    opacity: 1;
    animation: none;
  }
`;

export const MofoPromiseBar = (): JSX.Element => {
  const market = process.env.GATSBY_VM_MARKET;
  const promises = marketPromises[market];
  const [currentPromiseIndex, setCurrentPromiseIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setTimeout(() => {
        setCurrentPromiseIndex((prevIndex) =>
          prevIndex < promises.length - 1 ? prevIndex + 1 : 0
        );
      }, 500);
    }, 5000);

    return () => clearInterval(interval);
  }, [promises]);

  return (
    <Box textAlign="center" overflow="hidden">
      <Box display="inline-block">
        <Box display="flex" alignItems="center" py={4}>
          {promises.map(({ Icon, label }, index) => {
            return (
              <PromiseBox
                px="14px"
                display="flex"
                color="brand"
                alignItems="center"
                fade={index === currentPromiseIndex}
                show={index === currentPromiseIndex}
                key={index}
              >
                <Icon size="20px" />
                <Text
                  as="span"
                  variant="sm"
                  fontWeight={500}
                  fontSize={["12px", "14px"]}
                  color="text.heading"
                >
                  {label}
                </Text>
              </PromiseBox>
            );
          })}
        </Box>
      </Box>
    </Box>
  );
};
